import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_122: DocMigration = {
  maxSchemaVersion: "0.0.122",
  description: "Separate frieze board settings for dormers.",
  apply(json: any) {
    const { settings: allSettings } = json;

    for (const settingsId in allSettings) {
      const settings = allSettings[settingsId];
      if (settings.type !== "ROOF_SETTINGS") {
        continue;
      }

      settings.dormerRakeFriezeBoard = settings.rakeFriezeBoard;
      settings.dormerEaveFriezeBoard = settings.eaveFriezeBoard;
    }

    return json;
  },
};

export default migration_0_0_122;
